export default {
	SET_BOOKING_STATE : (state, data) =>{
        for (const key in data) {
            if (data.hasOwnProperty(key) && state.bookingState[key] != data[key]) {
                state.bookingState[key] = data[key];
            }
        }
    },
    SET_TERMS_CONDITION: (state, data) => {
        state.termsCondition = {
            ...state.termsCondition,
            ...data
        };
    },
    SET_SERVICE_GROUP: (state, data) => {
        state.serviceGroup = {
            ...state.serviceGroup,
            ...data
        };
    },
    SET_SERVICE_GROUP_ADDRESS: (state, data) => {
        state.serviceGroupAddress = {
            ...state.serviceGroupAddress,
            ...data
        };
    },
    SET_SERVICES: (state, data) => {
        state.services = {
            ...state.services,
            ...data
        };
    },
    SET_EXCLUDED_SERVICES_OF_SELECTED_ADDRESS_SETTING: (state, data) => {
        state.excludedServicesOfSelectedAddressSetting = {
            ...state.excludedServicesOfSelectedAddressSetting,
            ...data
        };
    },
    SET_ENTITLEMENT_GROUP: (state, data) => {
        state.entitlementGroup = {
            ...state.entitlementGroup,
            ...data
        };
    },
    SET_WORK_ORDER: (state, data) => {
        state.workOrder = {
            ...state.workOrder,
            ...data
        };
    },
    SET_GST_DATA: (state, data) => {
        state.GSTData = {
            ...state.GSTData,
            ...data
        };
    },
    SET_SERVICES_OF_SELECTED_SERVICE_GROUP: (state, data) => {
        state.servicesOfSelectedServiceGroup = {
            ...state.servicesOfSelectedServiceGroup,
            ...data
        };
    },
    SET_WASTE_STREAM: (state, data) => {
        state.wasteStreams = {
            ...state.wasteStreams,
            ...data
        };
    },
    SET_VIEW_WASTE_STREAMS: (state, data) => {
        state.viewWasteStreams = {
            ...state.viewWasteStreams,
            ...data
        };
    },
    SET_LOADED_WASTE_STREAMS: (state, data) => {
        const existingIds = new Set(
            state.loadedWasteStreams.map(item => item.waste_stream_setting_id)
        );

        state.loadedWasteStreams.push(
            ...data.filter(
            item => !existingIds.has(item.waste_stream_setting_id)
            )
        );
    },
    SET_ALL_WASTE_STREAMS: (state, data) => {
        state.allWasteStreams = {
            ...state.allWasteStreams,
            ...data
        };
    },
    SET_WOI_WASTE: (state, data) => {
        state.woiWasteTypes = {
            ...state.woiWasteTypes,
            ...data
        };
    },
    SET_WOI_ITEM_TYPE: (state, data) => {
        state.woiItemTypes = {
            ...state.woiItemTypes,
            ...data
        };
    },
    SET_ACTIVE_SERVICE_GROUP: (state, data) => {
        state.activeServiceGroup = { ...data };
    },
    SET_ACTIVE_SERVICE_SETTING: (state, data) => {
        state.activeServiceSetting = { ...data };
    },
    SET_WASTE_VARIATION: (state, data) => {
        state.wasteVariation = { ...data };
    },
    SET_MULTIPLE_COLLECTION: (state, data) =>{
        state.multipleCollection = {
            ...state.multipleCollection,
            ...data
        };
    },
    SET_SERVER_DATE: (state, data) => {
        state.getServerDate = {
            ...state.getServerDate,
            ...data
        };
    },
    SET_AVAILABLE_BOOKING_DATES_OF_ADDRESS: (state, data) =>{
        state.availableBookingDatesOfAddress = {
            ...state.availableBookingDatesOfAddress,
            ...data
        };
    },
    SET_SHOW_MODAL_RETRY: (state, data) =>{
        state.showModalRetry = data;
    },
    SET_SHOW_MODAL_ERROR: (state, data) =>{
        state.showModalError = data;
    },
    SET_PRICING: (state, data) => state.pricing = { ...state.pricing, ...data },
    SET_ACTIVEFORM_INDEX: (state, data) => {
        state.activeStepIndex = data;
    },
    SET_BOOKING_PRODUCTS: (state, data) => {
        state.selectedBookingProducts = [...data];
    },
    SET_BOOKING_ACKNOWLEDGE: (state, data) => {
        state.bookingAcknowledged = data;
    },
    SET_PAYMENT_INFO: (state, data) => {
        state.paymentInfo = { ...state.paymentInfo, ...data };
    },
    SET_BOOKING_SUBMISSION: (state, data) => {
        state.bookingSubmission = { ...state.bookingSubmission, ...data };
    },
    SET_GST_DEFAULT_DATA: (state, data) => {
        state.getDefaultData = data;
    },
    SET_BOOKING_SUMMARY_DETAILS: (state, data) => {
        state.bookingSummaryDetails = data;
    },
    SET_CRN: (state, data) => {
        state.crn = data;
    },
    SET_WASTE_COMBO: (state, data) => {
        state.wasteStreamsCombo = {...state.wasteStreamsCombo, ...data};
    },
    SET_WASTE_COMBO_LIST: (state, data) => {
        state.wasteStreamsComboList = {...state.wasteStreamsComboList, ...data};
    },
    SET_MAX_STREAM_PRICE : (state, data) => {
        state.maxStreamPrice = data
    },
    SET_IS_COLLECTION_WEEK_SHOWN : (state, data) => {
        state.isCollectionWeekShown = data
    },
    SET_SEARCH_INSTRUCTION_SETTINGS : (state, data) => {
        state.searchInstructionSettings = {...state.searchInstructionSettings, ...data}
    },
    SET_SERVICE_GROUP_WORDING : (state, data) => {
        state.serviceGroupWording = data
    },
    SET_ACTIVE_MULTIPLE_COLLECTION_SETTING : (state, data) => {
        state.activeMultipleCollectionSetting = data
    },
    SET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING: (state, data) => {
        state.activeMultipleServiceBookingSetting = { ...state.activeMultipleServiceBookingSetting, ...data };
    },
    SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS: (state, data) => {
        state.activeMultipleServiceSelectedBookingProducts = [...data];
    },
    SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES: (state, data) => {
        state.activeMultipleServiceSelectedBookingDates = [...data];
    },
    SET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS: (state, data) => {
        state.activeMultipleServiceAcceptedBookingTerms = [...data];
    },
    // SET_ACTIVE_MULTIPLE_SERVICE_MULTIPLE_COLLECTION_COUNT: (state, data) => {
    //     state.activeMultipleServiceMultipleCollectionCount = [...data];
    // },
    // SET_ACTIVE_MULTIPLE_SERVICE_COMPUTED_ENTITLEMENTS: (state, data) => {
    //     state.activeMultipleServiceComputedEntitlements = [...data];
    // },
    SET_ACTIVE_MULTIPLE_SERVICE_ENTITLEMENT_SUMMARIES: (state, data) => {
        state.activeMultipleServiceEntitlementSummaries = [...data];
    },
    SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE: (state, data) => {
        state.activeMultipleServiceOtherBookingState = [...data];
    },
    SET_BOOKING_COMPLETED_DETAILS: (state, data) => {
        state.bookingCompletedDetails = data;
    },
    SET_ADDITIONAL_QUESTIONS: (state, data) => {
        state.additionalQuestions = data;
    },
}
